export const dark = {
    colorTitle: '#FFFFFF',
    colorText: 'rgba(255, 255, 255, .7)',
    widgetBg: '#0A0E20', //? replace
    btnBg: '#3885C6',
    btnColor: '#fff',
    btnHoverBg: '#2369A3',
    btnHoverColor: '#fff',
    btnActiveBg: '#0C406A',
    btnActiveColor: '#fff',
    btnShadow: '#5D8FF18C',
    markingText: 'rgba(255, 255, 255, 0.6)',
};

export const orange = {
    colorTitle: '#0A0E20',
    colorText: '#303446',
    widgetBg: '#FFF7B2', //?
    btnBg: '#FF8719',
    btnColor: '#fff',
    btnHoverBg: '#FFA450',
    btnHoverColor: '#fff',
    btnActiveBg: '#C85413',
    btnActiveColor: '#fff',
    btnShadow: '#FF8F508C',
    markingText: 'rgba(48, 52, 70, 0.4)',
};

export const blue = {
    colorTitle: '#0A0E20',
    colorText: '#303446',
    widgetBg: '#F2F8FF', //?
    btnBg: '#0A0E20',
    btnColor: '#fff',
    btnHoverBg: '#4D5163',
    btnHoverColor: '#fff',
    btnActiveBg: '#303446',
    btnActiveColor: '#fff',
    btnShadow: '#00000012',
    markingText: 'rgba(48, 52, 70, 0.4)',
};
